import { RequestBuilder } from "../requestBuilder";
import {
  ConceptChunksSchema,
  ConceptsWithDistancesSchema,
  ConceptWithDistancesSchema,
  SeedWithDistancesSchema,
  ConceptsSyncSchema,
} from "./conceptClient.types";
import z from "zod";

export const GetAllConceptsRequestConfig = new RequestBuilder({
  path: () => "/concepts",
  responseSchema: ConceptsWithDistancesSchema,
});

export const GetConceptByIdRequestConfig = new RequestBuilder({
  path: (params) => `/concepts/${params.id}`,
  paramsSchema: z.object({
    id: z.string(),
  }),
  responseSchema: ConceptWithDistancesSchema,
});

export const GetSeedByIdRequestConfig = new RequestBuilder({
  path: (params) => `/concepts/${params.conceptId}/seeds/${params.seedId}`,
  paramsSchema: z.object({
    conceptId: z.string(),
    seedId: z.string(),
  }),
  responseSchema: SeedWithDistancesSchema,
});

export const GetConceptChunksRequestConfig = new RequestBuilder({
  path: (params) => `/concepts/${params.conceptId}/chunks`,
  paramsSchema: z.object({
    conceptId: z.string(),
  }),
  responseSchema: ConceptChunksSchema,
});

export const ConceptsSyncRequestConfig = new RequestBuilder({
  path: () => "/concepts-sync",
  responseSchema: ConceptsSyncSchema,
});
